import React from 'react';
import './index.less';

const PageBottom = props => {
    const { anchor, current } = props;
    console.log("current",current);
    
    return (
        <div className='pagebottom'>
            <div
                className="bottom_bg"
                style={{
                    width: `${anchor.totalWidth}px`,
                }}>
            </div>
            <div className='bottom_left'>
                <div className='bottom_title'>联系我们</div>
                <div className='bottom_content'>
                    电话：010-82152508
                </div>
                <div className='bottom_content'>
                    邮箱：
                    <a href='mailto:contact@aminer.cn' style={{ color: '#334',textDecoration:"underline" }}>
                        info@aminer.cn
                    </a>
                </div>
                <div className='bottom_content'>
                    地址：北京市海淀区中关村东路1号院6号楼科建大厦六层
                </div>
            </div>
            {/* <div className='bottom_right'>
                <div className='bottom_title'>关于智慧人才</div>
                <div className='bottom_content'><a href='http://aminer.cn' target='_blank' style={{color: 'black'}}>智谱华章</a></div>
                <div className='bottom_content'><a href='http://aminer.cn' target='_blank' style={{color: 'black'}}>AMiner</a></div>
            </div> */}
            <div className='bottom_footer'>
                {anchor.isMobile ? (
                    <div>
                        <p>京ICP备17059297号-2</p>
                        <p>2005-2020 © AMiner. All Rights Reserved.</p>
                    </div>
                ) : "2005-2020 © AMiner. All Rights Reserved. 京ICP备17059297号-2"
                }
            </div>
            {
                !!anchor.isMobile && current==5
                &&
                <img
                    src='/assets/arrow_up.png'
                    className='top_text_6'
                    style={{ width: `${anchor.scale * 26}px`, top:"83%", minWidth: 16 }}
                    />
            }
        </div>
    )
}

export default PageBottom;